var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sc-placeholder',{staticClass:"details-container",attrs:{"rendering":_vm.rendering,"name":"digital-house-editorial-component"}})}
var staticRenderFns = []

export { render, staticRenderFns }